<script setup lang="ts">
import { computed } from 'vue'
import type { Dataset, Document, Folder } from '../types'
import FolderManagement from './FolderManagement.vue'
import TagLibraryManagement from './TagLibraryManagement.vue'
import AdminFeedbackManagement from './AdminFeedbackManagement.vue'
import CurrentEventManagement from './CurrentEventManagement.vue'

const props = defineProps<{ datasetId: string; datasets: Dataset[]; documents: Document[]; folders: Folder[]; activeTab?: string }>()
const emit = defineEmits<{ refresh: []; 'update:activeTab': [string] }>()
const active = computed({ get: () => props.activeTab || 'upload', set: value => emit('update:activeTab', value) })
const tabs = [['upload', '入库上传'], ['folders', '文件夹管理'], ['tags', '标签库'], ['feedback', '意见问答'], ['events', '时事内容']]
</script>
<template>
  <div class="admin-tabs">
    <div class="subtabs"><button v-for="tab in tabs" :key="tab[0]" :class="['subtab', { active: active === tab[0] }]" @click="active = tab[0]">{{ tab[1] }}</button></div>
    <FolderManagement v-if="active === 'folders'" :dataset-id="datasetId" :folders="folders" :documents="documents" @refresh="emit('refresh')"/>
    <TagLibraryManagement v-else-if="active === 'tags'" :datasets="datasets"/>
    <AdminFeedbackManagement v-else-if="active === 'feedback'"/>
    <CurrentEventManagement v-else-if="active === 'events'"/>
  </div>
</template>
